export class LapiError extends Error {
  /**
   * @public
   */
  statusCode: number;

  constructor(statusCode: number, rawResponse: string) {
    super(`${statusCode}: ${rawResponse}`);
    this.name = 'LapiError';
    this.statusCode = statusCode;
  }
}
